import { ToggleButtonDesignTokens } from '@primeuix/themes/types/togglebutton';

export const ToggleButton: ToggleButtonDesignTokens = {
  root: {
    checkedColor: '{surface.0}',
    checkedBackground: '{green.700}',
  },
  content: {
    checkedBackground: '{green.700}',
  },
};
